var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { valueProviderCache } from '@juvare/common-form-ui/valueProviderCache';
import { getDataValue } from '@juvare/json-data-util';
export function getItems(_a) {
    return __awaiter(this, arguments, void 0, function* ({ values, valueProviderType, valueProvider, valueProvidersFromProps, filterData, formConfigContext, }) {
        if (values) {
            return values;
        }
        const valueProviderTypeToMatchAgainst = (valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.type) || valueProviderType;
        const valueProviders = valueProvidersFromProps !== null && valueProvidersFromProps !== void 0 ? valueProvidersFromProps : formConfigContext === null || formConfigContext === void 0 ? void 0 : formConfigContext.valueProviders;
        const matchedValueProvider = valueProviders === null || valueProviders === void 0 ? void 0 : valueProviders.find((vp) => vp.type === valueProviderTypeToMatchAgainst);
        if (matchedValueProvider) {
            let params = valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.params;
            if ((valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.paramsFromFormData) && filterData) {
                params = getDataValue(filterData, valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.paramsFromFormData);
            }
            return valueProviderCache.getValue(matchedValueProvider, params);
        }
        else {
            console.error('Value provider not found, type: ' + valueProviderTypeToMatchAgainst);
            return [];
        }
    });
}
